import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { createCommissionRuleType, fetchCommissionRuleTypes, updateCommissionRuleType, deleteCommissionRuleType, getComissionsReport, generateComissionsReport, editCommissionRecords, updatePageSize } from "./action";
import { CommissionRuleType } from "../../models/CommissionRuleType";
import { AllCommission, Commission, CommissionResponse } from "../../models/Commission";
import { pastPage, nextPage } from "./action";

interface CommissionRuleTypesState {
    state: CommissionRuleType[],
    isLoading: boolean,
    error: string | null,
}

interface CommissionsState {
  commissions: Commission[],
  isLoading: boolean,
  error: string | null,
  filters: {
    billingPeriod: string,
    status: string,
    carrier: string,
  }
}

const commissionRuleTypeInitialState: CommissionRuleTypesState = {
    state: [],
    isLoading: false,
    error: null,
}

const commissionsInitialState: CommissionsState = {
  commissions: [],
  isLoading: false,
  error: null,
  filters: {
    billingPeriod: "",
    status: "confirmed",
    carrier: "-1",
  }
}

// slice
export const commissionRuleTypesSliceReducer = createSlice({
    name: "commissionRuleTypes",
    initialState: commissionRuleTypeInitialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchCommissionRuleTypes.pending, (state) => {
          state.isLoading = true;
          state.state = [];
          state.error = null
        })
        .addCase(fetchCommissionRuleTypes.fulfilled, (state, action: PayloadAction<CommissionRuleType[]>) => {
          state.isLoading = false;
          state.state = action.payload;
          state.error = null
        })
        .addCase(fetchCommissionRuleTypes.rejected, (state, action: any) => {
          state.isLoading = false;
          state.state = [];
          state.error = action.payload;
        });

      builder
        .addCase(createCommissionRuleType.pending, (state) => {
          state.isLoading = true;
          state.error = null
        })
        .addCase(createCommissionRuleType.fulfilled, (state, action: PayloadAction<CommissionRuleType>) => {
          state.isLoading = false;
          state.state = state.state.concat(action.payload);
        })
        .addCase(createCommissionRuleType.rejected, (state, action: any) => {
          state.isLoading = false;
          state.error = action.payload;
        });

      builder
        .addCase(updateCommissionRuleType.pending, (state) => {
          state.isLoading = true;
          state.error = null
        })
        .addCase(updateCommissionRuleType.fulfilled, (state, action: PayloadAction<CommissionRuleType>) => {
          const updatedRule = action.payload;
          state.isLoading = false;
          const idx = state.state.findIndex(x => x.id === updatedRule.id);
          state.state[idx] = updatedRule;
        })
        .addCase(updateCommissionRuleType.rejected, (state, action: any) => {
          state.isLoading = false;
          state.error = action.payload;
        });

      builder
        .addCase(deleteCommissionRuleType.pending, (state) => {
          state.isLoading = true;
          state.error = null
        })
        .addCase(deleteCommissionRuleType.fulfilled, (state, action: PayloadAction<CommissionRuleType>) => {
          const deletedRule = action.payload;
          state.isLoading = false;
          const idx = state.state.findIndex(x => x.id === deletedRule.id);
          state.state.splice(idx, 1);
        })
        .addCase(deleteCommissionRuleType.rejected, (state, action: any) => {
          state.isLoading = false;
          state.error = action.payload;
        });
    },
}).reducer;

const commissionSliceReducer = createSlice({
  name: "commissions",
  initialState: commissionsInitialState,
  reducers: {
    setFilters(state, action: PayloadAction<{billingPeriod: string, status: string, carrier: string}>) {
      state.filters = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
    .addCase(getComissionsReport.pending, (state) => {
      state.isLoading = true;
      state.error = null
      state.commissions = [];
    })
    .addCase(getComissionsReport.fulfilled, (state, action: PayloadAction<CommissionResponse>) => {
      state.isLoading = false;
      state.commissions = action.payload.commissions;
      state.filters.status = action.payload.status;
    })
    .addCase(getComissionsReport.rejected, (state, action: any) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    builder
      .addCase(generateComissionsReport.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(generateComissionsReport.fulfilled, (state, action: PayloadAction<CommissionResponse>) => {
        state.isLoading = false;
        
        state.commissions = action.payload.commissions
      })
      .addCase(generateComissionsReport.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
    builder
      .addCase(editCommissionRecords.fulfilled, (state, action: PayloadAction<any>) => {
        action.payload.forEach((y: any) => {
          let idx = state.commissions.findIndex(x => x.id === y.id);
          if (idx !== -1) {
            state.commissions[idx] = { ...y}
          }
          })
      })
  },
});

export const { setFilters } = commissionSliceReducer.actions;
export default commissionSliceReducer.reducer;